import type ITenantMonthlyBillingRepository from '../ITenantMonthlyBillingRepository';
import type {
  StatusUpdateRq,
  TenantMonthlyBillingDTO,
  TenantBillingId,
  TenantBillingsFilters,
} from '../tenantMonthlyBilling.types';
import { type AxiosRequestConfig } from 'axios';
import { injectable } from 'inversify';
import qs from 'qs';
import API from '@repositories/Axios';
import { type FileSimpleDTO } from '@repositories/fileRepository/file.types';
import type { Page } from '@type/Page';

@injectable()
export class TenantMonthlyBillingRepository
  implements ITenantMonthlyBillingRepository
{
  async getOne(billingId: TenantBillingId): Promise<TenantMonthlyBillingDTO> {
    const result = await API.get<TenantMonthlyBillingDTO>(
      `/api/v1/tenant-monthly-billings/${billingId.id}/monthly-billings/${billingId.month}`
    );
    return result.data;
  }
  async getList(
    queries?: TenantBillingsFilters
  ): Promise<Page<TenantMonthlyBillingDTO>> {
    const queryString = qs.stringify(queries, {
      arrayFormat: "repeat",
      skipNulls: true,
    });
    const result = await API.get<Page<TenantMonthlyBillingDTO>>(
      `/api/v1/tenant-monthly-billings?${queryString}`
    );
    return result.data;
  }
  async update(/* id: string, data: unknown */): Promise<TenantMonthlyBillingDTO> {
    throw new Error("Method not implemented.");
  }

  async delete(billingId: TenantBillingId): Promise<void> {
    await API.delete<void>(
      `/api/v1/tenant-monthly-billings/${billingId.id}/monthly-billings/${billingId.month}`
    );
  }

  async updateStatus(rqData: StatusUpdateRq): Promise<TenantMonthlyBillingDTO> {
    const result = await API.put<TenantMonthlyBillingDTO>(
      `/api/v1/tenant-monthly-billings/${rqData.tenantId}/monthly-billings/${rqData.month}/status`,
      rqData
    );
    return result.data;
  }

  async fileUpload(
    tenantId: string,
    month: string,
    files: File[],
    config?: AxiosRequestConfig
  ): Promise<FileSimpleDTO[]> {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    const result = await API.post<FileSimpleDTO[]>(
      `/api/v1/tenant-monthly-billings/${tenantId}/monthly-billings/${month}/files`,
      formData,
      {
        ...config,
        headers: {
          ...config?.headers,
          "Content-Type": undefined, // FormData 사용 시 Content-Type을 브라우저가 자동 설정하도록 함
        },
      }
    );
    return result.data;
  }

  async fileDelete(
    tenantId: string,
    month: string,
    fileId: string
  ): Promise<void> {
    await API.delete(
      `/api/v1/tenant-monthly-billings/${tenantId}/monthly-billings/${month}/files/${fileId}`
    );
  }
}
